import { gql } from '__generated__';

export default gql(`
  mutation DeactivateTicket($id: ID!) {
    deactivateTicket(id: $id) {
      id
      active
    }
  }
`);
